<template>
    <div>
        <EventEntryOverview
            class="event-overview"
            :event="event"
            :hide-categories="hideCategories" />
        <EventEntryDetailsCollapser
            class="event-details-collapser"
            :event="event"
            :expanded-by-default="expandedByDefault" />
    </div>
</template>

<script>
import EventEntryOverview from "@/components/pages/eventIFrame/EventEntry/EventEntryOverview/EventEntryOverview";
import EventEntryDetailsCollapser from "@/components/pages/eventIFrame/EventEntry/EventEntryDetailsCollapser";

export default {
    name: "EventEntryMain",
    components: {EventEntryDetailsCollapser, EventEntryOverview},
    props: {
        event: {
            type: Object,
            required: true
        },
        expandedByDefault: {
            type: Boolean,
            default: false
        },
        iFrameType: {
            type: String,
            required: true
        },
        parentUrl: {
            type: String
        },
        embedStructuredData: {
            type: Boolean,
            default: false
        },
        hideCategories: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.event-overview {
    position: relative;
    z-index: 2;
}

.event-details-collapser {
    position: relative;
    z-index: 1;
}
</style>
